export const palette = {
    background: {
        default: "#FAFAFA",
    },
    verge: {
        primary: "#E6E8FF",
    },
};
